import React from 'react';
import {StyleSheet, View} from 'react-native';
import CCText from '@/Atoms/CCText';
import {lbColors} from '../leaderboardTheme';

interface Props {
  trend: 'up' | 'down' | 'flat';
  value?: number | null;
}

/** Up / down / flat rank-movement indicator. */
export default function TrendPill({trend, value}: Props) {
  const color =
    trend === 'up'
      ? lbColors.green
      : trend === 'down'
      ? lbColors.red
      : lbColors.faint;
  const glyph = trend === 'up' ? '▲' : trend === 'down' ? '▼' : '—';
  return (
    <View style={styles.trend}>
      <CCText fontSize={11} fontWeight="bold" color={color}>
        {glyph}
      </CCText>
      {value != null ? (
        <CCText fontSize={13} fontWeight="bold" color={color}>
          {value}
        </CCText>
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  trend: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 3,
  },
});
